import { IconButton, Tooltip } from '@mui/material';
import { AndroidIcon } from './AndroidIcon';
import { IosIcon } from './IosIcon';

export function DeviceInfo({ deviceDescription }) {
  return deviceDescription ? (
    <Tooltip title={JSON.stringify(deviceDescription)}>
      <IconButton>
        <AndroidIcon />
      </IconButton>
    </Tooltip>
  ) : (
    <IosIcon />
  );
}
